import type { OnInit} from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'ppl-app-container',
    templateUrl: './app-container.component.html',
    styleUrls: ['./app-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppContainerComponent implements OnInit {

  @Input() showCopyright = true;

  currentDate = new Date();

  constructor() { }

  ngOnInit() { }

}
